import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {OrganizationData} from '../../types/organization/organization';
import {HttpClient, HttpParams} from '@angular/common/http';
import {OrganizationInputData} from '../../types/organization/organization-input-data';
import {Region} from '../../types/organization/region';
import {Organization} from '../../types/person/organization';
import {BaseRestService} from '../common/BaseRestService';
import {SystemType} from '../../types/common/system-type';
import {InteractionData} from '../../types/interaction/interaction-data';
import {CustomWidgetData} from "../../types/custom-widgets/custom-widget-data";

@Injectable()
export class OrganizationRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('organizations');
  }

  getAllOrganizations(type: SystemType, region?: Region): Observable<Organization[]> {
    const params: HttpParams = new HttpParams()
      .set('type', SystemType[type]);

    if (region) {
      params.set('region', String(region.id));
    }

    return this.http.get<Organization[]>(this.getEndpoint(), {params});
  }

  getAllOrganizationData(id: number): Observable<OrganizationData> {
    return this.http.get<OrganizationData>(this.getEndpoint([String(id), 'detail']));
  }

  save(organizationInputData: OrganizationInputData, files: File[]): Observable<OrganizationData> {
    const formData: FormData = new FormData();

    for (const file of files) {
      formData.append('file_data', file, file.name);
    }

    const dtoData = new Blob([JSON.stringify(organizationInputData)], {
      type: 'application/json',
    });

    formData.append('organization', dtoData);
    if (organizationInputData.id) {
      return this.http.put<OrganizationData>(this.getEndpoint([String(organizationInputData.id)]),
        formData);
    }
    return this.http.post<OrganizationData>(this.getEndpoint(), formData);
  }

  updateInteraction(id: number, interactions: InteractionData[]): Observable<any> {
    const formData: FormData = new FormData();
    const dtoData = new Blob([JSON.stringify(interactions)], {
      type: 'application/json',
    });

    formData.append('interaction', dtoData);
    return this.http.put<InteractionData>(this.getEndpoint([id.toString(), 'interaction']), formData);
  }

  updateWidgets(id: number, widgets: CustomWidgetData[]): Observable<any> {
    console.log('Widgets');
    console.log(widgets);
    console.log(JSON.stringify(widgets));
    console.log([JSON.stringify(widgets)]);

    const formData: FormData = new FormData();
    const dtoData = new Blob([JSON.stringify(widgets)], {
      type: 'application/json',
    });

    formData.append('widgets', dtoData);
    return this.http.put<CustomWidgetData>(this.getEndpoint([id.toString(), 'widgets']), formData);
  }

  deleteOrganization(id: number): Observable<any> {
    return this.http.delete<any>(this.getEndpoint([String(id)]));
  }

}
